module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-4"
  }, [_c('p', [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Subject:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.data.subject))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Message:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.data.message))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Created On:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.data.createdOn)))])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-space-between": "",
      "row": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-0 mx-0",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      Close\n    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 mx-0",
    attrs: {
      "disabled": _vm.data.isRead,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.markAsRead()
      }
    }
  }, [_vm._v("\n      Mark as read\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c92bad5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ShowSubject.vue
// module id = 577
// module chunks = 29